{
  "brand": { "name": "SUiiLife Official", "tagline": "Sống chất lượng trọn thảnh thơi", "logo": "/brand/suiilife-logo.png" },
  "hero": [
    { "src": "/site-images/hero/hero-01.png", "alt": "Thiết bị SUII trong không gian bếp gia đình" },
    { "src": "/site-images/hero/hero-02.png", "alt": "Lò nướng và máy xay SUII trong căn bếp ấm áp" },
    { "src": "/site-images/hero/hero-03.png", "alt": "Bộ sưu tập đồ gia dụng SUII" },
    { "src": "/site-images/hero/hero-04.png", "alt": "Gia đình quây quần bên bữa ăn cùng SUII" }
  ],
  "carouselIntervalMs": 4200,
  "detail": { "src": "/site-images/detail/detail-01.png", "alt": "Giới thiệu nồi cơm điện SUII" },
  "featured": [
    { "src": "/site-images/featured-products/featured-01.png", "alt": "Bộ dao nhà bếp SUII" },
    { "src": "/site-images/featured-products/featured-02.png", "alt": "Máy băm thực phẩm SUII" },
    { "src": "/site-images/featured-products/featured-03.png", "alt": "Máy xay SUII" }
  ],
  "warranty": { "src": "/site-images/warranty/warranty-01.png", "alt": "Thông tin bảo hành và sản phẩm chính hãng SUII" },
  "collectionTitle": "KOLEKSI PRODUK SUII",
  "contactTitle": "TEMUKAN SUII DI SINI",
  "collections": [
    { "src": "/site-images/collections/collection-01.png", "alt": "Bộ sưu tập sản phẩm SUII 01" },
    { "src": "/site-images/collections/collection-02.png", "alt": "Bộ sưu tập sản phẩm SUII 02" },
    { "src": "/site-images/collections/collection-03.png", "alt": "Bộ sưu tập sản phẩm SUII 03" },
    { "src": "/site-images/collections/collection-04.png", "alt": "Bộ sưu tập sản phẩm SUII 04" }
  ],
  "contact": {
    "title": "Trung tâm dịch vụ liên hệ",
    "email": "lienhe@suiilife.vn",
    "phone": "0376815465",
    "copyright": "Copyright 2026 © SUiiLife Official",
    "socials": [
      { "type": "instagram", "label": "Instagram", "url": "https://www.instagram.com/" },
      { "type": "tiktok", "label": "TikTok", "url": "https://www.tiktok.com/" },
      { "type": "youtube", "label": "YouTube", "url": "https://www.youtube.com/" }
    ]
  }
}
